import { Navigate, Outlet } from 'react-router-dom'
import { usePortalContext } from '../lib/portalContext'
import { RouteLoader } from './RouteLoader'

// Inverse of RequireOrganization. Keeps org admins out of the creator subtree
// (and out of GET /partners/access, which would mint a stray PartnerAccess row),
// routing them to their own portal instead.
export function RequireNotOrganization() {
  const { data, isLoading, error } = usePortalContext()
  if (isLoading) return <RouteLoader />
  // On an unknown membership check, don't let an org admin fall into the
  // creator subtree (which would mint a stray PartnerAccess row) — throw to
  // the ErrorBoundary instead.
  if (error) throw error
  if (data?.selected.kind === 'organization') return <Navigate to="/org/audio" replace />
  return <Outlet />
}
